import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private http: HttpClient) {
  }

  public exportVupchForm(userId: any): Promise<any> {
    return this.http.get(`${environment.api_url}/vupch/${userId}/export`, {responseType: 'blob'})
      .pipe(
        map((res: any) => {
          return res;
        })
      ).toPromise();
  }

  public exportVtcForm(id: any): Promise<any> {
    return this.http.get(`${environment.api_url}/vtc/${id}/export`, {responseType: 'blob'})
      .pipe(
        map((res: any) => {
          return res;
        })
      ).toPromise();
  }

  public exportOspForm(studyProgrammeId: number, formType: 'VHSSP' | 'OSP' | 'OSP_EN'): Promise<any> {
    return this.http.get(`${environment.api_url}/study_programme/${studyProgrammeId}/export?exportType=${formType}`, {responseType: 'blob'})
      .pipe(
        map((res: any) => {
          return res;
        })
      ).toPromise();
  }

  public exportOHKIKForm(hkikId: number, formType: 'OHKIK' | 'OHKIK_EN'): Observable<any> {
    return this.http.get(`${environment.api_url}/habilitation_inauguration/${hkikId}/export?exportType=${formType}`,
      {responseType: 'blob'});
  }

  public exportEvaluationForm(id: any): Promise<any> {
    return this.http.get(`${environment.api_url}/evaluation/${id}/export`, {responseType: 'blob'})
      .pipe(
        map((res: any) => {
          return res;
        })
      ).toPromise();
  }
}
